import { useQuery } from 'react-query';
import { listFormulaCardTypeMappings } from 'api/gql-utils/overtime/queries';
import type { OTFormulaCardTypeMapping } from 'api/gql-utils/overtime/types';

export const OT_FORMULA_CARD_TYPE_MAPPINGS_QUERY_KEY = 'ot-formula-card-type-mappings';

export function useOtFormulaCardTypeMappings() {
  return useQuery({
    queryKey: [OT_FORMULA_CARD_TYPE_MAPPINGS_QUERY_KEY],
    queryFn: () => listFormulaCardTypeMappings(),
    select: (response): OTFormulaCardTypeMapping[] =>
      response.overtimeListFormulaCardTypeMappings.data.typeMappings || [],
  });
}
